module.exports = __webpack_public_path__ + "static/media/kirthika-international.a45e8fc3.png";